import BaseService from '@/services/BaseService'
import {http} from './config'
class EntradaMercadoriaService extends BaseService {
    constructor(){
        super('/v1/entradas/mercadorias')
    }

    listar(data){
        // const queryParams = `id=${data.id ? data.id : ''}
        // &chave_nfe=${data.chave_nfe ? data.chave_nfe : ''}
        // &numero_nota=${data.numero_nota ? data.numero_nota : ''}
        // &fornecedor=${data.fornecedor ? data.fornecedor : ''}
        // &status=${data.status ? data.status : ''}
        // &data_entrada=${data.data_entrada ? data.data_entrada : ''}`

        return http.get(`/v1/entradas/mercadorias`, {params: data})
    }

    imprimir(id){
        return http.get(`/v1/entradas/mercadorias/${id}/imprimir`)
    }

    enviarEmail(data){
        return http.post(`/v1/entradas/mercadorias/enviar/email`, data)
    }

}
export default new EntradaMercadoriaService